import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcHome(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 19.501c0 .138.112.25.25.25H19a.25.25 0 0 0 .25-.25V9.977a.25.25 0 0 0-.093-.194l-7-5.687a.25.25 0 0 0-.314 0l-7 5.687a.25.25 0 0 0-.093.194V19.5c0 .138.112.25.25.25h3.75a.25.25 0 0 0 .25-.25v-4.8a.95.95 0 0 1 .95-.95h4.1a.95.95 0 0 1 .95.95zm5.75 0a1.75 1.75 0 0 1-1.75 1.75h-3.75a1.75 1.75 0 0 1-1.75-1.75v-4.25h-3v4.25a1.75 1.75 0 0 1-1.75 1.75H5a1.75 1.75 0 0 1-1.75-1.75V9.977c0-.527.238-1.025.646-1.358l7-5.687a1.75 1.75 0 0 1 2.207 0l7 5.687c.41.333.647.831.647 1.358z"
  }));
}
var IcHome = createNolIcon(/*#__PURE__*/forwardRef(SvgIcHome));

export { IcHome as I };
